<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';
import { validRequired } from '@/common/elementValid.js';
import emailHostSer from '@/backend/services/emailHost/emailHostSer.js';

function getFormData(_obj, vm) {
	let { attributes } = vm;
	let { deleteMail, emailDomain, imapHost, inbox, junkMail, sent, smtpHost } = attributes;
	return {
		emailDomain: {
			label: '邮箱域名：',
			formType: 'sky-input',
			value: emailDomain || '',
			rules: [validRequired('请填写域名')],
		},
		imapHost: {
			label: '收件服务器：',
			formType: 'sky-input',
			value: imapHost || '',
			rules: [validRequired('请填写收件服务器')],
		},
		smtpHost: {
			label: '发件服务器：',
			formType: 'sky-input',
			value: smtpHost || '',
			rules: [validRequired('请填写发件服务器')],
		},
		inbox: {
			label: '收件箱：',
			formType: 'sky-input',
			value: inbox || '',
			rules: [validRequired('请填写收件箱')],
		},
		sent: {
			label: '已发送：',
			formType: 'sky-input',
			value: sent || '',
			rules: [validRequired('请填写已发送')],
		},
		deleteMail: {
			label: '已删除邮件：',
			formType: 'sky-input',
			value: deleteMail || '',
		},
		junkMail: {
			label: '垃圾邮件：',
			formType: 'sky-input',
			value: junkMail || '',
		},
	};
}

async function submit(data) {
	let { attributes } = this;
	let { id } = attributes;
	try {
		if (id)
			await emailHostSer.emailHostEdit({
				id,
				...data,
			});
		else await emailHostSer.emailHostAdd(data);
		this.$message.success(id ? '修改成功' : '新增成功');
		this.$emit('confirm');
	} catch (error) {
		this.formData.loading = false;
	}
}

function cancel(self) {
	self.$emit('cancel');
}

function onShowLoad(props) {
	return props || {};
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
	},
	{
		labelWidth: '110px',
	}
);

export default formDialogCreate({
	name: 'emailHostForm',
	onShowLoad,
	componentForm,
});
</script>

<style scoped lang="scss"></style>
